module.exports = __webpack_public_path__ + "static/media/restriction.9421539e.svg";